// Paths of the verifier firm's surface that render OUTSIDE the org tree (verifier-firm-foundation).

/** Signed in, usually with no org: a removed member who followed an invite. */
export const VERIFIER_BLOCKED_PATH = '/verifier/blocked';

export const isVerifierBlockedPath = (pathname) => pathname === VERIFIER_BLOCKED_PATH;

const ENGAGEMENT_DIAGRAM = /^\/verifier\/engagements\/[^/]+\/diagrams\/[^/]+(\/plan)?\/?$/;

/**
 * An engagement's diagram or plan (phase 4). It renders in the audit shell — full screen, with a
 * back link to the engagement — so it skips the AppLayout chrome, but it stays inside the org
 * tree (PrivateRoute, OrgBoundary): unlike `/audit/*`, a verifier HAS a workspace. Also exempt from
 * the mobile block, like the audit surface: verifiers arrive from email.
 */
export const isVerifierWorkspacePath = (pathname) =>
  typeof pathname === 'string' && ENGAGEMENT_DIAGRAM.test(pathname);

/** One engagement's page in the verifier workspace. */
export const engagementPath = (engagementId) => `/verifier/engagements/${engagementId}`;
